import { cardsData } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100">精选推荐</h2>
          <p className="text-sm text-foreground-500 mt-3">编辑部精心挑选的优质内容</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {cardsData.map((item, i) => (
            <div key={i} className={`group rounded-xl overflow-hidden bg-background-100 border border-background-200/50 hover:border-primary-500/30 transition-all cursor-pointer ${
              i === 0 ? 'sm:col-span-2 xl:col-span-2' : ''
            }`}>
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full bg-primary-500/90 text-[10px] font-semibold text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-100 line-clamp-2 leading-snug">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-2 line-clamp-2 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}